/* US SAKASYU "Shio" theme: header, menu, cart drawer, reveals, hero slides, rails, journey, omakase, cursor fish */
(function () {
  'use strict';
  var d = document, w = window, root = d.documentElement;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var S = w.skShop || { money: '${{amount}}', freeShip: 8000, cartUrl: '/cart', addUrl: '/cart/add', changeUrl: '/cart/change' };
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }

  function money(cents) {
    var n = (cents / 100).toFixed(2), parts = n.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return S.money.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_with_comma_separator') return parts[0] + ',' + parts[1];
      return withCommas;
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function toast(msg) {
    var t = $('.sk-toast');
    if (!t) { t = d.createElement('div'); t.className = 'sk-toast'; t.setAttribute('role', 'status'); d.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2400);
  }

  /* ---------- Header: solid on scroll, hide on the way down ---------- */
  var header = $('[data-sk-header]'), lastY = 0, prog = $('.sk-progress span');
  function onScroll() {
    var y = w.scrollY;
    if (header) {
      header.classList.toggle('is-scrolled', y > 40);
      header.classList.toggle('is-hidden', y > 400 && y > lastY && !root.classList.contains('is-menu'));
    }
    if (prog) {
      var max = d.documentElement.scrollHeight - w.innerHeight;
      prog.style.setProperty('--p', max > 0 ? (y / max).toFixed(3) : 0);
    }
    lastY = y;
  }
  w.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Full screen menu ---------- */
  var menuBtn = $('[data-sk-menu-open]'), menu = $('[data-sk-menu]');
  function setMenu(open) {
    root.classList.toggle('is-menu', open);
    if (menuBtn) menuBtn.setAttribute('aria-expanded', open);
    if (menu) menu.setAttribute('aria-hidden', !open);
  }
  if (menuBtn) menuBtn.addEventListener('click', function () { setMenu(!root.classList.contains('is-menu')); });
  if (menu) menu.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });

  /* ---------- Cart drawer ---------- */
  var drawer = $('[data-sk-drawer]');
  function setCount(n) {
    $$('[data-sk-cart-count]').forEach(function (el) { el.textContent = n; });
    var c = $('.sk-cart');
    if (c) { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); }
  }
  function renderCart(cart) {
    if (!drawer) return;
    var body = $('[data-sk-drawer-body]', drawer);
    if (!cart.items.length) {
      body.innerHTML = '<div class="sk-drawer__empty"><span class="sk-jp">からっぽです</span><p>Your cart is empty for now.</p><a class="sk-btn" href="/collections/all">Browse the pantry</a></div>';
    } else {
      body.innerHTML = cart.items.map(function (it) {
        var img = it.image ? '<img src="' + esc(it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=240') + '" alt="">' : '';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="sk-dl__var">' + esc(it.variant_title) + '</span>' : '';
        return '<div class="sk-dl" data-key="' + esc(it.key) + '">' +
          '<a class="sk-dl__pic" href="' + esc(it.url) + '">' + img + '</a>' +
          '<div class="sk-dl__info"><a class="sk-dl__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
          '<span class="sk-dl__qty"><button type="button" data-sk-q="' + (it.quantity - 1) + '" aria-label="Less">&minus;</button><span>' + it.quantity + '</span><button type="button" data-sk-q="' + (it.quantity + 1) + '" aria-label="More">+</button></span></div>' +
          '<div class="sk-dl__right"><span class="sk-dl__price">' + money(it.final_line_price) + '</span><br><button type="button" class="sk-dl__rm" data-sk-q="0">Remove</button></div>' +
          '</div>';
      }).join('');
    }
    $('[data-sk-drawer-total]', drawer).textContent = money(cart.total_price);
    var ship = $('[data-sk-drawer-ship]', drawer), left = S.freeShip - cart.total_price;
    if (ship) {
      ship.innerHTML = (cart.total_price === 0 ? 'Free U.S. shipping on orders over ' + money(S.freeShip) + '.' :
        left > 0 ? 'You are ' + money(left) + ' away from free shipping.' : 'Nice! Your order ships free.') +
        '<i style="--f:' + Math.min(1, cart.total_price / S.freeShip).toFixed(3) + '"></i>';
    }
    setCount(cart.item_count);
  }
  function fetchCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    fetchCart().then(renderCart);
  }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); } }
  $$('[data-sk-cart-open]').forEach(function (a) {
    if (d.body.classList.contains('sk--cart')) return;
    a.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
  });
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-sk-drawer-close]')) closeDrawer();
      var q = e.target.closest('[data-sk-q]');
      if (q) {
        var line = q.closest('[data-key]');
        drawer.classList.add('is-busy');
        fetch(S.changeUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.getAttribute('data-key'), quantity: parseInt(q.getAttribute('data-sk-q'), 10) }) })
          .then(function (r) { return r.json(); }).then(renderCart)
          .finally(function () { drawer.classList.remove('is-busy'); });
      }
    });
  }
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); setMenu(false); } });

  function addToCart(items, btn) {
    if (btn) btn.setAttribute('aria-busy', 'true');
    return fetch(S.addUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { openDrawer(); })
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Sorry, that could not be added.'); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }
  d.addEventListener('click', function (e) {
    var q = e.target.closest('[data-sk-quick-add]');
    if (!q) return;
    e.preventDefault();
    q.classList.add('is-done');
    addToCart([{ id: parseInt(q.getAttribute('data-sk-quick-add'), 10), quantity: 1 }], q).then(function () { setTimeout(function () { q.classList.remove('is-done'); }, 1200); });
  });

  /* ---------- Product page ---------- */
  $$('[data-sk-product]').forEach(function (pdp) {
    var form = $('form[data-sk-product-form]', pdp) || $('.sk-pdp__form', pdp);
    var main = $('[data-sk-gallery-main]', pdp);
    $$('[data-sk-thumb]', pdp).forEach(function (t) {
      t.addEventListener('click', function () {
        var img = main && $('img', main);
        if (!img) return;
        $$('[data-sk-thumb]', pdp).forEach(function (x) { x.classList.toggle('is-on', x === t); });
        main.classList.add('is-swap');
        setTimeout(function () { img.removeAttribute('srcset'); img.src = t.getAttribute('data-sk-thumb'); main.classList.remove('is-swap'); }, 220);
      });
    });
    $$('[data-sk-qty]', pdp).forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = $('input[name="quantity"]', pdp);
        inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.getAttribute('data-sk-qty'), 10));
      });
    });
    var data = $('[data-sk-variants]', pdp), variants = [];
    try { variants = JSON.parse(data.textContent); } catch (e) {}
    var opts = $$('[data-sk-option]', pdp);
    function pickVariant() {
      var chosen = opts.map(function (f) { var c = $('input:checked', f); return c ? c.value : null; });
      var v = variants.filter(function (v) { return chosen.every(function (val, i) { return v.options[i] === val; }); })[0];
      if (!v) return;
      $('[data-sk-variant-id]', pdp).value = v.id;
      var price = $('[data-sk-price]', pdp);
      if (price) price.innerHTML = (v.price > 0 ? money(v.price) : 'Coming soon') + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '');
      var btn = $('[data-sk-add]', pdp), label = $('[data-sk-add-label]', pdp), ok = v.available && v.price > 0;
      btn.disabled = !ok;
      label.textContent = ok ? 'Add to cart' : v.price === 0 ? 'Coming soon' : 'Sold out';
      if (v.featured_image && main && $('img', main)) { var img = $('img', main); img.removeAttribute('srcset'); img.src = v.featured_image.src; }
      if (history.replaceState) history.replaceState(null, '', location.pathname + '?variant=' + v.id);
    }
    opts.forEach(function (f) { f.addEventListener('change', pickVariant); });
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = $('[data-sk-add]', pdp);
        addToCart([{ id: parseInt($('[data-sk-variant-id]', pdp).value, 10), quantity: parseInt($('input[name="quantity"]', pdp).value, 10) || 1 }], btn);
      });
    }
  });

  /* ---------- Collection sort ---------- */
  $$('[data-sk-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString();
    });
  });

  /* ---------- Reveal on scroll ---------- */
  var revealSel = '.sk-head, .sk-label, .sk-story__side, .sk-card, .sk-rail__more, .sk-press__card, .sk-omakase__copy, .sk-omakase__stage, .sk-aisles__row, .sk-coll__hero .sk-wrap, .sk-footer__hello, .sk-footer__cols, .sk-pdp__info';
  $$(revealSel).forEach(function (el) { if (!el.closest('.sk-hero')) el.classList.add('sk-reveal'); });
  $$('.sk-grid__item .sk-card').forEach(function (el) { el.style.setProperty('--d', el.parentNode.style.getPropertyValue('--d') || 0); });
  if ('IntersectionObserver' in w && !reduce) {
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { (en.target._skFor || en.target).classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .05 });
    $$('.sk-reveal').forEach(function (el) { io.observe(el); });
    // Clipped elements never count as visible, so watch their parent instead
    $$('.sk-reveal-img').forEach(function (el) { var p = el.parentNode; p._skFor = el; io.observe(p); });
  } else {
    $$('.sk-reveal, .sk-reveal-img').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Statement lights up word by word ---------- */
  $$('[data-sk-words]').forEach(function (p) {
    var words = p.textContent.trim().split(/\s+/);
    p.innerHTML = words.map(function (wd) { return '<span class="w">' + esc(wd) + '</span>'; }).join(' ');
    var spans = $$('.w', p);
    function lit() {
      var r = p.getBoundingClientRect(), vh = w.innerHeight;
      var t = (vh * .85 - r.top) / (r.height + vh * .35);
      var n = Math.round(Math.max(0, Math.min(1, t)) * spans.length);
      spans.forEach(function (s, i) { s.classList.toggle('is-lit', i < n); });
    }
    if (reduce) { spans.forEach(function (s) { s.classList.add('is-lit'); }); return; }
    w.addEventListener('scroll', lit, { passive: true }); lit();
  });

  /* ---------- Count up ---------- */
  $$('[data-sk-count]').forEach(function (el) {
    var end = parseInt(el.getAttribute('data-sk-count'), 10), start = end - 120, done = false;
    if (!end || reduce || !('IntersectionObserver' in w)) return;
    el.textContent = start;
    new IntersectionObserver(function (ents, o) {
      if (!ents[0].isIntersecting || done) return;
      done = true; o.disconnect();
      var t0 = performance.now();
      (function step(t) {
        var k = Math.min(1, (t - t0) / 1600), e = 1 - Math.pow(1 - k, 4);
        el.textContent = Math.round(start + (end - start) * e);
        if (k < 1) requestAnimationFrame(step);
      })(t0);
    }).observe(el);
  });

  /* ---------- Hero slideshow ---------- */
  $$('[data-sk-hero]').forEach(function (hero) {
    var slides = $$('.sk-hero__slide', hero), dots = $$('.sk-hero__dots li', hero), i = 0;
    if (slides.length < 2 || reduce) return;
    setInterval(function () {
      slides[i].classList.remove('is-on'); if (dots[i]) dots[i].classList.remove('is-on');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-on'); if (dots[i]) dots[i].classList.add('is-on');
    }, 5600);
  });

  /* ---------- Aisles: open on hover / focus ---------- */
  $$('[data-sk-aisles]').forEach(function (row) {
    var items = $$('.sk-aisle', row);
    function open(a) { items.forEach(function (x) { x.classList.toggle('is-open', x === a); }); }
    items.forEach(function (a) { a.addEventListener('mouseenter', function () { open(a); }); a.addEventListener('focus', function () { open(a); }); });
  });

  /* ---------- Rails: drag, arrows, progress ---------- */
  $$('[data-sk-rail]').forEach(function (rail) {
    var sec = rail.closest('section'), bar = sec && $('[data-sk-rail-bar]', sec);
    function upd() {
      if (!bar) return;
      var max = rail.scrollWidth - rail.clientWidth;
      bar.parentNode.style.display = max > 4 ? '' : 'none';
      bar.style.setProperty('--w', Math.min(1, rail.clientWidth / rail.scrollWidth).toFixed(3));
      bar.style.setProperty('--x', max > 0 ? (rail.scrollLeft / max).toFixed(3) : 0);
    }
    rail.addEventListener('scroll', upd, { passive: true }); w.addEventListener('resize', upd); upd();
    function step(dir) { var it = $('.sk-rail__item', rail); rail.scrollBy({ left: dir * ((it ? it.offsetWidth : 300) + 24) * 2, behavior: 'smooth' }); }
    if (sec) {
      var p = $('[data-sk-rail-prev]', sec), n = $('[data-sk-rail-next]', sec);
      if (p) p.addEventListener('click', function () { step(-1); });
      if (n) n.addEventListener('click', function () { step(1); });
    }
    var down = false, sx = 0, sl = 0, moved = 0;
    rail.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = 0; sx = e.clientX; sl = rail.scrollLeft; });
    w.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx; moved = Math.abs(dx);
      if (moved > 6) rail.classList.add('is-drag');
      rail.scrollLeft = sl - dx;
    });
    w.addEventListener('pointerup', function () { down = false; setTimeout(function () { rail.classList.remove('is-drag'); }, 0); });
    rail.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
    rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
  });

  /* ---------- Journey: vertical scroll drives a sideways trip ---------- */
  $$('[data-sk-journey]').forEach(function (sec) {
    var track = $('[data-sk-journey-track]', sec), boat = $('.sk-journey__route', sec), mq = w.matchMedia('(min-width: 990px)'), dist = 0;
    function size() {
      if (!mq.matches || reduce) { sec.style.height = ''; track.style.transform = ''; return; }
      dist = Math.max(0, track.scrollWidth - w.innerWidth + 80);
      sec.style.height = (w.innerHeight + dist) + 'px';
      move();
    }
    function move() {
      if (!mq.matches || reduce) return;
      var r = sec.getBoundingClientRect(), p = Math.max(0, Math.min(1, -r.top / Math.max(1, dist)));
      track.style.transform = 'translate3d(' + (-p * dist).toFixed(1) + 'px,0,0)';
      if (boat) boat.style.setProperty('--p', p.toFixed(3));
    }
    w.addEventListener('scroll', move, { passive: true });
    w.addEventListener('resize', size);
    w.addEventListener('load', size);
    size();
  });

  /* ---------- Omakase noren ---------- */
  $$('[data-sk-omakase]').forEach(function (sec) {
    var list = [];
    try { list = JSON.parse($('[data-sk-omakase-data]', sec).textContent); } catch (e) {}
    var go = $('[data-sk-omakase-go]', sec), stage = $('.sk-omakase__stage', sec), pick = $('[data-sk-omakase-pick]', sec), busy = false, last = -1;
    if (!list.length) { if (go) go.hidden = true; return; }
    function card(p, shuffle) {
      return '<span class="sk-omakase__plate' + (shuffle ? ' is-shuffle' : '') + '"><img src="' + esc(p.i) + '" alt=""></span>' +
        '<span class="sk-omakase__name">' + esc(p.t) + '</span>';
    }
    function run() {
      if (busy) return;
      busy = true;
      var open = sec.classList.contains('is-open');
      sec.classList.remove('is-open');
      setTimeout(function () {
        sec.classList.add('is-open');
        var k = 0, spins = reduce ? 0 : 12;
        (function spin() {
          var idx = Math.floor(Math.random() * list.length);
          if (k < spins) { pick.innerHTML = card(list[idx], true); k++; setTimeout(spin, 60 + k * 12); return; }
          if (list.length > 1) while (idx === last) idx = Math.floor(Math.random() * list.length);
          last = idx;
          var p = list[idx];
          pick.innerHTML = card(p, false) + '<span class="sk-omakase__price">' + esc(p.p) + '</span>' +
            '<span class="sk-omakase__acts"><button type="button" class="sk-btn" data-sk-quick-add="' + p.v + '">Add to cart</button><a class="sk-btn sk-btn--ghost" href="' + esc(p.u) + '">See it</a></span>';
          if (go) go.firstChild.nodeValue = 'One more, please ';
          busy = false;
        })();
      }, open ? 700 : 50);
    }
    if (go) go.addEventListener('click', run);
    if (stage) stage.addEventListener('click', function (e) { if (!e.target.closest('a, button')) run(); });
  });

  /* ---------- Cursor fish + bubbles ---------- */
  var fish = $('.sk-fish');
  if (fish && !reduce && w.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var mx = -100, my = -100, fx = -100, fy = -100, ang = 0, seen = false;
    w.addEventListener('pointermove', function (e) { mx = e.clientX; my = e.clientY; if (!seen) { seen = true; fx = mx; fy = my; fish.classList.add('is-on'); } }, { passive: true });
    d.addEventListener('mouseleave', function () { fish.classList.remove('is-on'); seen = false; });
    (function loop() {
      var dx = mx - fx, dy = my - fy;
      fx += dx * .12; fy += dy * .12;
      if (Math.abs(dx) + Math.abs(dy) > 2) {
        var diff = ((Math.atan2(dy, dx) * 180 / Math.PI - ang) % 360 + 540) % 360 - 180;
        ang += Math.max(-8, Math.min(8, diff * .2));
      }
      var flip = Math.cos(ang * Math.PI / 180) < 0 ? -1 : 1;
      fish.style.transform = 'translate3d(' + (fx + 14).toFixed(1) + 'px,' + (fy + 10).toFixed(1) + 'px,0) rotate(' + ang.toFixed(1) + 'deg) scaleY(' + flip + ') scaleX(-1)';
      requestAnimationFrame(loop);
    })();
    d.addEventListener('click', function (e) {
      for (var i = 0; i < 4; i++) {
        var b = d.createElement('span'), s = 5 + Math.random() * 8;
        b.className = 'sk-bubble';
        b.style.cssText = 'left:' + (e.clientX + (Math.random() * 30 - 15)) + 'px;top:' + (e.clientY + (Math.random() * 20 - 10)) + 'px;width:' + s + 'px;height:' + s + 'px;animation-delay:' + (i * 60) + 'ms';
        d.body.appendChild(b);
        setTimeout(function (el) { el.remove(); }.bind(null, b), 1500);
      }
    });
  }
})();
